import { apBasePath } from "./_base";

export const apPathAddons = apBasePath.appendPathSegment("/addons");